module.exports = __webpack_public_path__ + "static/stress-financial-situation-bfd1de2378dcc7b79da024ad40812f2f.svg";